// import React from "react";
// import "../../styles/ContactUs.css";
// import { FaEnvelope } from "react-icons/fa";

// const ContactUs = () => {
//   return (
//     <div className="bg-gradient-to-br from-blue-200 to-blue-600">
//       <div className="background">
//         <div className="container-contactus ">
//           <div className="screen mt-[200px]">
//             <div className="screen-header">
//               <div className="screen-header-left">
//                 <div className="screen-header-button close"></div>
//                 <div className="screen-header-button maximize"></div>
//                 <div className="screen-header-button minimize"></div>
//               </div>
//               <div className="screen-header-right">
//                 <div className="screen-header-ellipsis"></div>
//                 <div className="screen-header-ellipsis"></div>
//                 <div className="screen-header-ellipsis"></div>
//               </div>
//             </div>
//             <div className="screen-body flex flex-col md:flex-row">
//               <div className="screen-body-item left md:w-1/2">
//                 <div className="app-title mb-5">
//                   <span>
//                     CONTACT
//                     <strong />
//                   </span>
//                   <span>
//                     US
//                     <strong />
//                   </span>
//                 </div>
//                 <div className="app-contact">
//                   {/* <span className=" block">CONTACT INFO :</span>{" "} */}
//                   <div className="">Tel : (+202) 24515146</div>
//                   <div className="">Fax : (+202) 24557205</div>
//                   <div className="font-medium">Mobile : (+2) 01144001046 </div>
//                   <div className="font-medium">Mail: info@dtec-eg.com</div>
//                   <div className="font-medium">
//                     Find Us: 3 Ahmed Farid, Al Matar, El Nozha, Cairo
//                     Governorate{" "}
//                   </div>
//                 </div>
//               </div>
//               {/* <div className="screen-body-item mr-[30px] md:w-1/2">
//                 <div className="app-form">
//                   <div>
//                     <span className="grid">
//                       CEO:
//                       <a
//                         className="no-underline"
//                         href="mailto:tamer.ismaeel@dtec-eg.com"
//                       >
//                         tamer.ismaeel@dtec-eg.com
//                       </a>
//                     </span>
//                   </div>
//                   <div>
//                     <FaEnvelope />
//                     <span className="grid">
//                       Technical office manager:
//                       <a
//                         className="no-underline"
//                         href="mailto:ahmed.attia@dtec-eg.com"
//                       >
//                         ahmed.attia@dtec-eg.com
//                       </a>
//                     </span>
//                   </div>
//                   <div>
//                     <FaEnvelope />
//                     <span className="grid">
//                       Financial Manager:
//                       <a
//                         className="no-underline"
//                         href="mailto:osama.,twally@dtec-eg.com"
//                       >
//                         osama.mtwally@dtec-eg.com
//                       </a>
//                     </span>
//                   </div>
//                   <div>
//                     <FaEnvelope />
//                     <span className="grid">
//                       Technical Office Engineer:
//                       <a
//                         className="no-underline"
//                         href="mailto:somaya.tamer@dtec-eg.com"
//                       >
//                         somaya.tamer@dtec-eg.com
//                       </a>
//                     </span>
//                   </div>
//                   <FaEnvelope />
//                 </div>
//               </div> */}
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;

import React from "react";
import { motion } from "framer-motion";
import {
  FaPhoneAlt,
  FaFax,
  FaMobileAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const ContactUs = () => {
  return (
    <div className="bg-gradient-to-br from-[#201C59] via-white to-[#201C59] min-h-screen flex items-center justify-center py-12 sm:py-16">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="w-full max-w-5xl bg-gradient-to-br from-white to-gray-50 shadow-2xl rounded-3xl p-6 sm:p-10 border border-gray-100 backdrop-blur-sm"
      >
        {/* Title */}
        <h2 className="mb-5 text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-10 text-[#201C59]">
          Contact Us
        </h2>

        {/* Info Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="space-y-6 text-base sm:text-lg"
          >
            <div className="flex items-center gap-3">
              <FaPhoneAlt className="text-[#201C59] text-lg sm:text-xl" />
              <span>Tel: (+202) 24515146</span>
            </div>
            <div className="flex items-center gap-3">
              <FaFax className="text-[#201C59] text-lg sm:text-xl" />
              <span>Fax: (+202) 24557205</span>
            </div>
            <div className="flex items-center gap-3">
              <FaMobileAlt className="text-[#201C59] text-lg sm:text-xl" />
              <span>Mobile: (+2) 01144001046</span>
            </div>
            <div className="flex items-center gap-3">
              <FaEnvelope className="text-[#201C59] text-lg sm:text-xl" />
              <a href="mailto:info@dtec-eg.com" className="text-[#201C59] hover:underline">
                info@dtec-eg.com
              </a>
            </div>
            <div className="flex items-start gap-3">
              <FaMapMarkerAlt className="text-[#201C59] text-lg sm:text-xl mt-1" />
              <a
                href="https://maps.app.goo.gl/EzKb8YckK4sYJsay9"
                target="_blank"
                rel="noopener noreferrer"
                class="text-[#201C59] underline"
              >
                Find Us: 3 Mohamed Farid Heliopolis, Cairo.
              </a>
            </div>
          </motion.div>

          {/* Right Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.2 }}
            viewport={{ once: true }}
            className="flex flex-col items-center justify-center bg-gradient-to-br from-[#201C59] to-[#3A348F] text-white rounded-2xl p-6 sm:p-8 shadow-lg"
          >
            <h3 className="text-xl sm:text-2xl font-bold mb-4">Get in Touch</h3>
            <p className="text-center mb-6 text-sm sm:text-base opacity-90">
              We’re here to help and answer any questions you might have. Reach
              out and we’ll respond as soon as possible.
            </p>
            <a
              href="mailto:info@dtec-eg.com?subject=Inquiry%20from%20Website&body=Hello%20DTEC%20Team,%0D%0A%0D%0AName:%20%0D%0APhone:%20%0D%0AMessage:%20"
              className="bg-white text-[#201C59] font-bold px-6 py-3 rounded-full shadow-md hover:shadow-lg transition text-sm sm:text-base"
            >
              Send Email
            </a>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default ContactUs;
